import React, { useState } from "react";
import Style from "./TaxiCurrentTravelDetail.module.css";
import { Divider } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInfo,
  faMapPin,
  faMoneyBillWave,
  faPhone,
} from "@fortawesome/fontawesome-free-solid";
import { separate } from "./../../Seprate/Seprate";
import { userCancelTaxiApi, userPayTaxiApi } from "../../Api/ClientServices";
import { errorToast, succToast } from "../../Toast/Toast";
import { faAddressBook } from "@fortawesome/free-solid-svg-icons";

const TaxiCurrentTravelDetail = ({ data }) => {
  const [loadingState, setLoadingState] = useState(false);
  const payTaxiHandler = () => {
    setLoadingState(true);
    let infoData = {
      id: data.id,
      payment_type: "pgw",
    };
    userPayTaxiApi(infoData, (succ, res) => {
      if (succ) {
        if (res.status === 1) {
          window.open(res.link, "_self");
          setLoadingState(false);
        } else {
          errorToast(res.message);
          setLoadingState(false);
        }
      } else {
        console.error(res);
        setLoadingState(false);
      }
    });
  };
  const cancelRequestHanlder = () => {
    setLoadingState(true);
    let info = {
      id: data.id,
      cause: "",
    };
    userCancelTaxiApi(info, (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          setLoadingState(false);
          errorToast(res.message);
        } else {
          succToast("درخواست شما لغو شد!");
          setLoadingState(false);
        }
      } else {
        console.error(res);
        setLoadingState(false);
      }
    });
  };
  return (
    <div className={Style.ComponentHolder}>
      <section className={Style.PartHolder}>
        <Divider>آدرس</Divider>
        <p>
          <FontAwesomeIcon icon={faMapPin} color="#d00d8f" />
          مبدا:{data?.routes_description.split("**")[0]}
        </p>
        <p>
          <FontAwesomeIcon icon={faMapPin} color="#d00d8f" />
          مقصد:{data?.routes_description.split("**")[1]}
        </p>
        {data?.routes_description.split("**")[2] && (
          <p>
            <FontAwesomeIcon icon={faMapPin} color="#d00d8f" />
            مقصد دوم:{data?.routes_description.split("**")[2]}
          </p>
        )}
        {data?.description && (
          <p>
            <FontAwesomeIcon icon={faAddressBook} color="#d00d8f" />
             توضیحات:{data?.description}
          </p>
        )}
      </section>
      {data.status !== "0" ? (
        <section className={Style.PartHolder}>
          <Divider>اطلاعات راننده</Divider>
          <div className={Style.DriverInfoHolder}>
            <div className={Style.ProfileHolder}>
              <img
                src={`https://cdn.barest.ir/deliver/photo/${data.driver.photo}.jpg`}
                alt=""
              />
            </div>
            <div className={Style.DriverInfoPartOne}>
              <h6>{data.driver.name}</h6>
              <p>
                {data.driver.vehicle_model} {data.driver.vehicle_color}
              </p>
            </div>
            <div className={Style.DriverInfoParttwo}>
              <p className={Style.CarPlateHolder}>
                {data.driver.vehicle_plate}
              </p>
              <a
                href={`tel:${data.driver.phone}`}
                className={Style.DriverPhoneHolder}
              >
                <FontAwesomeIcon icon={faPhone} /> تماس با راننده
              </a>
            </div>
          </div>
        </section>
      ) : null}
      <section className={Style.PartHolder}>
        <Divider>هزینه</Divider>
        <div className={Style.PricePartHolder}>
          <p>
            <FontAwesomeIcon icon={faMoneyBillWave} color="#d00d8f" /> 
            <span style={{ color: "green" }}>
              کرایه:{separate(data?.delivery)} تومان
            </span>
          </p>
          {data.paid !== "0" ? (
            <p style={{ fontSize: "0.7rem", color: "green" }}>پرداخت شده!</p>
          ) : (
            <button
              onClick={payTaxiHandler}
              disabled={loadingState}
              style={
                loadingState
                  ? {
                      background: "#fff",
                      color: "rgb(143, 9, 76)",
                      borderColor: "rgb(143, 9, 76)",
                    }
                  : null
              }
            >
              پرداخت
            </button>
          )}
        </div>
      </section>
      <section className={Style.PartHolder}>
        <Divider>وضعیت درخواست</Divider>
        <div className={Style.PricePartHolder}>
          <p className={Style.RequestStatusHolder}>
            <FontAwesomeIcon icon={faInfo} color="#d00d8f" /> 
            {data.status === "0"
              ? "منتظر تایید راننده"
              : data.status === "1"
              ? "راننده در مسیر مبدأ"
              : data.status === "2"
              ? "راننده در مبدأ است!"
              : data.status === "3"
              ? "در مسیر مقصد!"
              : null}
          </p>
        </div>
        {data.status === "0" || data.status === "1" ? (
          <button
            className={Style.cancelRequest}
            onClick={cancelRequestHanlder}
            disabled={loadingState}
          >
            {loadingState ? "لطفا صبرکنید..." : "لغو درخواست"}
          </button>
        ) : null}
      </section>
    </div>
  );
};

export default TaxiCurrentTravelDetail;
